import { useRef } from 'react'

// Components
import Lottie from '@/components/common/Lottie'

interface ILottieIconProps {
  animationData: object
  className?: string
}

/** 循環播放的 Lottie 圖示，大小跟著外層 className（同 Insight 的用法） */
const LottieIcon = ({ animationData, className }: ILottieIconProps) => {
  const lottieRef = useRef<HTMLSpanElement>(null)

  return (
    <span ref={lottieRef} className={className} aria-hidden>
      <Lottie lottieRef={lottieRef} animationData={animationData} config={{ loop: true, autoplay: true }} />
    </span>
  )
}

export default LottieIcon
